import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { QrCodeService } from '../qr-code/qr-code.service';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class QrCodeDataResolverService  {
  constructor(private service: QrCodeService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    const petId = route.paramMap.get('id');
    const isPreviewMode = !!route.queryParams && route.queryParams.preview;

    return this.service.getQrCodeData(parseInt(petId, 10), isPreviewMode).pipe(
      catchError((err) => {
        if (
          err instanceof HttpErrorResponse &&
          err.error.error_code === 'pet_deceased'
        ) {
          this.router.navigate(['/pet-deceased']);
        }
        if (err instanceof HttpErrorResponse && err.status === 404) {
          this.router.navigate(['/404']);
        }
        return throwError(err);
      })
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class QrCodePreferencesResolverService  {
  constructor(private service: QrCodeService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    const petId = route.paramMap.get('id');

    return this.service.getQrCodePreferencesForPet(parseInt(petId, 10)).pipe(
      catchError((err) => {
        console.log('resolver got err');
        if (err instanceof HttpErrorResponse && err.status === 404) {
          this.router.navigate(['/404']);
        }
        return throwError(err);
      })
    );
  }
}
